<template>
  <div class="row">
    <div class="col">
      <p></p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <blog-host />
    </div>
  </div>
</template>
<script>
import BlogHost from '@/components/blog/blog-listing.vue'
export default {
  name: 'HomePage',
  components: {
    BlogHost
  }
}
</script>
<style lang="scss" scoped></style>
